module.exports = __webpack_public_path__ + "img/courtmatter_icon.fd0c3e42.svg";